module.exports = __webpack_public_path__ + "img/top-border-slot.fb76a933.png";